import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const servicedeskCmdbInsightObjectSchemaConfigurationRoute: InvariantJiraRoute = {
	name: 'servicedesk-cmdb-object-schema-configuration',
	path: '/jira/servicedesk/insight/configure/object-schema/:objectSchemaId',
};
